import React, { useState } from 'react'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { layerManage } from '@/utils/layer'
import { Column, Expaned, Row } from '@/components/layout/layout'
import { Spin, Table } from 'antd'
import FormTitle from '../../../components/form/form-title/form-title'
import useSetDataTogether from '@/utils/hooks/useSetDataTogether'
import { StockReturnList, ReturnGoodsList } from '../stock-return-table/stock-return-table'
import { getBEMCls } from '@/utils/classname'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { ColumnsType } from 'antd/lib/table'

import './stock-return-detail.scss'

interface StockReturnDetailProps {
    id: number
}

const StockReturnDetail: React.FC<StockReturnDetailProps> = props => {
    const [loading, setLoading] = useState<boolean>(true)
    const [detailInfo, setDetailInfo] = useState<null | StockReturnList>(null)
    const setAllData = useSetDataTogether()

    const cls = (...arg: string[]) => getBEMCls('stock-return-detail', ...arg)

    useRequest(
        () =>
            $post({
                url: '/warehouse/getpurchaserefundorder',
                params: {
                    purchase_refund_id: props.id,
                },
            }),
        {
            onSuccess: res => {
                setAllData(() => {
                    setDetailInfo(res.purchase_refund_list[0])
                    setLoading(false)
                })
            },
        },
    )

    const columns: ColumnsType<ReturnGoodsList> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '退货商品',
            key: 'goods_list',
            dataIndex: 'goods',
            render: val => val.name,
        },
        {
            title: '退货量',
            key: 'refund_amount',
            dataIndex: 'refund_amount',
            render: (val, record) => `${val}${record.goods.stock_unit.name}`,
        },
        {
            title: '剩余库存',
            key: 'goods_stock',
            dataIndex: 'goods',
            render: val => val.stock,
        },
    ]

    return (
        <BaseDrawer
            title="退货详情"
            onClose={() => {
                layerManage.pop()
            }}
            isShow
        >
            <Column data-height-100p>
                <Expaned data-overflow-auto>
                    <Spin spinning={loading}>
                        <div className={cls('container')}>
                            <Column data-justify-content-center data-expaned>
                                <div className={cls('list-item')}>
                                    <div className="title coll">退货时间：</div>
                                    <div className="txt">{detailInfo?.create_time}</div>
                                </div>

                                <div data-margin-top-12 className={cls('list-item')}>
                                    <div className="title coll">操作人：</div>
                                    <Row className="txt" data-align-items-center>
                                        <img
                                            data-margin-right-6
                                            src={detailInfo?.creator?.user.avatar}
                                            alt=""
                                            className="avatar"
                                        />
                                        <div data-width-126 className="text-popper">
                                            {detailInfo?.creator?.user.realname || detailInfo?.creator?.user.nickname}
                                        </div>
                                    </Row>
                                </div>
                            </Column>
                            <Column data-justify-content-center data-expaned>
                                <div className={cls('list-item')}>
                                    <div className="title coll">状态：</div>
                                    <div className="txt">已退款</div>
                                </div>
                                <div data-margin-top-12 className={cls('list-item')}>
                                    <div className="title coll">退货单号：</div>
                                    <div className="txt">{detailInfo?.order_no}</div>
                                </div>
                            </Column>
                        </div>
                        <FormTitle title="退货清单" hasLine={false} />
                        <div className={cls('table-container')}>
                            <Table
                                columns={columns}
                                rowKey={r => r.id}
                                dataSource={detailInfo?.goods_list}
                                pagination={false}
                                bordered
                            ></Table>
                        </div>
                    </Spin>
                </Expaned>
            </Column>
        </BaseDrawer>
    )
}

export default StockReturnDetail
